module.exports = __webpack_public_path__ + "img/jn.5ba67c2b.png";